export default __webpack_public_path__ + "static/media/lottery2.c102ba82.jpg";